import React from "react";
import teethLogo from "../../assets/Images/teeth-logo.png";

const TeethLogo = ({ heading, text1, text2 }) => {
    return (
        <div className="main">
            <div className="teeth-logo-container">
                <div className="teeth-logo-div">
                    <img className="teeth-logo" src={teethLogo} alt="teethLogo" />
                    <h2 className="service-heading">
                        {heading}
                    </h2>
                </div>
                {text1 ? <div className='service-page-text-div'>
                    <p>{text1}</p>
                </div> : null}
                {text2 ? <div className='service-page-text-div'>
                    <p>{text2}</p>
                </div> : null}
            </div>
        </div>
    )
}
export default TeethLogo